import styled from 'styled-components'
import { css, radiuses } from 'styles'

const sizes = {
  // notifications + user panel
  compact: css`
    width: 3.5rem;
    height: 3.5rem;
  `,
  // vertical thumbnails
  thumbnail: css`
    width: 6rem;
    height: 6rem;
  `,
  responsive: css`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  `,
}

const overlay = css`
  ${sizes.responsive}
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const StyledAvatar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  border-radius: ${p => (radiuses[p.size] || radiuses.large)(p)};

  ${p =>
    p.size === 'responsive' &&
    css`
      &::before {
        content: '';
        display: block;
        margin-top: 100%;
      }
    `}

  .avatar-img {
    box-sizing: border-box;
    background-color: rgba(214, 214, 214, 0.3);
    // background-image: url(${p => p.src});  // set in JSX due to performance/blink issues
    background-size: cover;
    background-position: center;
    ${p => sizes[p.size]};
    transition: 0.3s filter;

    &:not(.with-filter) {
      ${p => !p.mine && !/photo_xxx/.test(p.src) && 'transform: scale(1.25);'}
    }
    ${p => p.type != 'normal' && !/photo_xxx/.test(p.src) && 'filter: blur(4px);'}
  }
  .avatar-text {
    ${overlay}
    padding: 0 1rem;
    pointer-events: none;
    font-size: ${p => (p.size == 'compact' ? 1 : 2)}rem;
    font-weight: bold;
    text-transform: uppercase;
    color: #fff;
    background: rgba(0,0,0,0.4);
    opacity: ${p => (/sexy|xxx/.test(p.type) ? 1 : 0)};
    transition: 0.3s opacity;
    ${p => p.type == 'xxx' && p.trial && p.size == 'responsive' && 'padding-bottom: 30%;'}
  }

  .avatar-upgrade {
    ${overlay}
    top: 50%;
    color: #fff;
    padding: 1rem;
    font-size: 1rem;
  }
`

export default StyledAvatar
